import React from 'react';

interface BannerModuleProps {
  text: React.ReactNode;
  onClickEvent?: () => void;
  variant?: 'strong' | 'light';
}

const BannerModule: React.FC<BannerModuleProps> = ({ text, onClickEvent, variant = 'strong' }) => {
  const base = variant === 'light' ? 'bg-blue-50 border-blue-200 text-blue-800' : 'bg-blue-100 border-blue-500 text-blue-900';
  const border = variant === 'light' ? 'border-l-4 border-blue-200' : 'border-l-4 border-blue-500';
  const textClass = variant === 'light' ? 'text-blue-800' : 'text-blue-900';
  const buttonClass =
    variant === 'light'
      ? 'mt-2 px-4 py-2 bg-blue-200 text-blue-900 rounded font-semibold shadow hover:bg-blue-300 transition-colors duration-150 w-fit cursor-pointer'
      : 'mt-2 px-4 py-2 bg-blue-600 text-white rounded font-semibold shadow hover:bg-blue-700 transition-colors duration-150 w-fit cursor-pointer';
  return (
    <div className={`p-4 mb-4 rounded shadow-sm sticky-banner-module flex flex-col gap-2 ${base} ${border}`}>
      <span className={`font-semibold text-xs ${textClass}`}>{text}</span>
      {onClickEvent && (
        <button className={buttonClass} onClick={onClickEvent}>
          Learn More
        </button>
      )}
    </div>
  );
};

export default BannerModule;
